import { useState, useEffect } from 'react';
import {useListingFilters} from "@/utils/listing-utils.ts";

/**
 * Search Filter in the Policy Library Listing
 */
export default function SearchFilter() {
    const { search, setQuery } = useListingFilters();

    //State needed to sync search box with searchParams while also allowing user to type in the search box
    const [searchValue, setSearchValue] = useState(search?.search || '');
    const searchQuery = search?.search || '';

    // Keep local state in sync with URL state
    useEffect(() => {
        setSearchValue(searchQuery)
    }, [searchQuery])


    //Debounce function for performance, so that a query doesn't go out for every single keystroke
    useEffect(() => {
        if (searchQuery === searchValue) return;
        const delayDebounce = setTimeout(() => {
                setQuery(searchValue || undefined);
        }, 400); // Adjust debounce time (ms) here

        return () => clearTimeout(delayDebounce); // Cleanup on next keystroke
    }, [searchValue]);

    const onChange = (e: React.ChangeEvent<HTMLInputElement>) => setSearchValue(e.target.value);
    return (
      <input type="search" id="search-filters" className="Finder__input h5" placeholder="Search by Keyword" value={searchValue} onChange={onChange} name="search" aria-label="Search by Keyword" />
    );
}